export default __webpack_public_path__ + "static/media/dashboard.e9e34e2e.svg";